import script from "./tabBar.vue?vue&type=script&setup=true&name=tabbar&lang=js"
export * from "./tabBar.vue?vue&type=script&setup=true&name=tabbar&lang=js"

import "./tabBar.vue?vue&type=style&index=0&id=19505ffa&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19505ffa"]])

export default __exports__